import { AbstractSource } from "../../../../../infrastructure/drawing";
import { IContentSource } from "../../../../../domain/drawing";

export class EditableFormatPreviewSource extends AbstractSource {
  constructor(getToken: () => string, public id: number, public archiveId: number = null) {
    super(getToken);
    if (id === undefined) {
      throw new Error("id is empty!!!");
    }
  }

  protected getSource(): string {
    // TODO:キャッシュするならここで実装する.とりあえずはソース文字列を返す.
    const url = (this.archiveId == null) 
      ? "/api/format-editor/format/" + this.id + "/view?token=" + this.token
      : "/api/format-editor/format/" + this.id + "/view/" + this.archiveId + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatPreviewSource(
      this._getToken,
      this.id
    );
  }
}
